import { findIndexByPropertyValue } from 'utilities/collection';
import socialAccountProviderTypes from 'constants/social-account-provider-types';

import {
  buildStateParameter,
  buildGoogleOauthURL,
  findSignInProvider,
  buildSignInURL,
  withEngagementScope
} from './utilities';

class SocialNetworksManager {

  constructor(application, serverInterface) {

    this.application = application;
    this.serverInterface = serverInterface;

    this.connectedToGoogleCalendar = false;

  }

  // The screens that open with the connection already resolved hand it over here.
  setConnectedToGoogleCalendar(connected) {

    this.connectedToGoogleCalendar = connected;

  }

  async isConnectedToGoogleCalendar() {

    this.connectedToGoogleCalendar = await this.serverInterface.currentUser.isConnectedToGoogleCalendar();

    return this.connectedToGoogleCalendar;

  }

  async tryConnectGoogleCalendar() {

    const connected = await this.isConnectedToGoogleCalendar();

    if (connected === true) {
      return true;
    }

    const configuration = await this.serverInterface.authentication.getGoogleCalendarOAuthConfiguration();

    const confirmed = await this.application.prompts.confirm({
      header: 'Connect to google calendar?',
      description: 'You have not connected to google calendar. Would you like to connect now?',
      confirmButtonText: 'Yes',
      cancelButtonText: 'Later'
    });

    if (confirmed === false) {
      return false;
    }

    const returnURL = `${window.location.origin}/google-calendar-authorization/callback?origin=${encodeURIComponent(window.location.href)}`;
    const state = {
      returnURL
    };
    const url = buildGoogleOauthURL(configuration, state);

    window.location.href = url;

    return true;

  }

  // Only a startup that acts on Facebook through the API asks for the permissions to read and answer
  // comments there. Without the startup's modes, the sign-in asks for the rest.
  async engagesOnFacebook() {

    try {
      const modes = await this.serverInterface.startup.community.socialPostActions.getSocialPostActionModes();
      return modes[socialAccountProviderTypes.FACEBOOK] !== undefined;
    } catch (exception) {
      return false;
    }

  }

  async readSignInConfiguration(signInProvider, configuration) {

    if (signInProvider !== socialAccountProviderTypes.FACEBOOK || await this.engagesOnFacebook() === false) {
      return configuration;
    }

    return withEngagementScope(configuration);

  }

  async startAccountSignIn(provider, dialogName) {

    const signInProvider = findSignInProvider(provider);
    const state = buildStateParameter(dialogName);
    const configurations = await this.serverInterface.authentication.getSocialAccountIntegrationConfigurations(state);
    const configuration = await this.readSignInConfiguration(signInProvider, configurations[findIndexByPropertyValue(configurations, 'name', signInProvider)]);

    window.location.href = buildSignInURL(signInProvider, configuration, state);

  }

}

export default SocialNetworksManager;